"use client";

import Image from "next/image";
import { getAvatar } from "@/lib/avatar";

const BORDER_STYLES: Record<string, string> = {
  blue: "ring-[3px] ring-primary/50",
  gold: "ring-[3px] ring-secondary/60",
  animated: "ring-[3px] ring-secondary/60 animate-pulse",
};

interface AvatarWithBorderProps {
  /** URL avatar siap pakai (server/RSC atau hasil fetch). Kosong → fallback `seed`. */
  src?: string | null;
  /** Seed fallback (nama/email) — dipakai HANYA bila `src` kosong. */
  seed?: string;
  alt: string;
  size?: number;
  border?: string | null;
  level?: number;
  className?: string;
}

/**
 * Avatar bulat + ring level. Avatar server-known masuk lewat `src` (string
 * dari RSC); bila kosong, fallback DiceBear dibangun sinkron dari `seed`
 * (`getAvatar` — modul isomorfik `@/lib/avatar`, deterministik per seed
 * sehingga SSR dan hydration selalu sepakat).
 */
export const AvatarWithBorder = ({
  src,
  seed,
  alt,
  size = 40,
  border,
  level,
  className = "",
}: AvatarWithBorderProps) => {
  const resolved = getAvatar(src, seed ?? alt);
  const borderStyle = border ? BORDER_STYLES[border] || "" : "";

  return (
    <div
      className={`relative shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <div
        className={`bg-border h-full w-full overflow-hidden rounded-full ${borderStyle}`}
      >
        {resolved ? (
          <Image
            src={resolved}
            alt={alt}
            width={size}
            height={size}
            className="h-full w-full"
          />
        ) : null}
      </div>
      {level != null && (
        <div className="bg-secondary text-foreground shadow-soft-xs absolute -right-0.5 -bottom-0.5 flex h-4.5 min-w-4.5 items-center justify-center rounded-full px-1 text-[9px] font-black [--soft-shadow-color:var(--secondary)]">
          {level}
        </div>
      )}
    </div>
  );
};
